<div class="row mb-3">
    <div class="col-sm-12">
        <div class="inputWithIcon inputWithIcon-search float-right d-flex">
            <app-advanced-mode id="designerSummaryGridExpandedSwitch" class="pr-4"
                [storageKey]="'formly-designer-summary-expanded'" [titleKey]="'EXPANDED'"
                (collapsibleToggle)="toggleExpandable($event)">
            </app-advanced-mode>
            <app-advanced-mode id="designerSummaryGridAdvancedSwitch" [storageKey]="'formly-designer-summary-advanced'"
                (collapsibleToggle)="enableAdvanced=$event">
            </app-advanced-mode>
        </div>
    </div>
</div>
<kendo-grid #summaryGrid [data]="rulesView.gridData" [loading]="rulesView.loading" [pageable]="false" [navigable]="true"
    [pageSize]="rulesView.state.take" [skip]="rulesView.state.skip" [sortable]="{ mode: 'multiple'}"
    [sort]="rulesView.state.sort" [filterable]="enableAdvanced" [filter]="rulesView.state.filter" [groupable]="false"
    [group]="rulesView.groups" [selectable]="{ mode: 'single' }" [columnMenu]="enableAdvanced" [resizable]="true"
    [reorderable]="enableAdvanced" (groupChange)="groupChange($event, rulesView)"
    (dataStateChange)="dataStateChange($event, rulesView)" style="margin-top:-8px;">
    <kendo-grid-messages noRecords="{{ 'NO-RULES-SUMMARY' | translate }}">
    </kendo-grid-messages>
    <kendo-grid-column field="categoryName" [width]="80" title="{{ 'CATEGORY' | translate }}"></kendo-grid-column>
    <kendo-grid-column field="rule.htmlData" [width]="400" title="{{ 'RULES' | translate }}" [groupable]="false"
        [filterable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
            <pre class="narrative" style="display:flex;white-space:break-spaces;">
                <div [innerHTML]="dataItem.rule.htmlData"></div>
            </pre>
        </ng-template>
    </kendo-grid-column>
    <ng-template kendoGridDetailTemplate let-dataItem>
        <div [ngSwitch]="dataItem.category">
            <kendo-grid [data]="dataItem.view.gridData" [pageable]="false" [pageSize]="dataItem.view.state.take"
                [navigable]="true" [skip]="dataItem.view.state.skip" [sortable]="true" [sort]="dataItem.view.state.sort"
                [filterable]="false" [filter]="dataItem.view.state.filter" [groupable]="false"
                [group]="dataItem.view.groups" [selectable]="{ mode: 'single' }" [columnMenu]="enableAdvanced"
                [resizable]="true" [reorderable]="enableAdvanced" (groupChange)="groupChange($event, dataItem.view)"
                (dataStateChange)="dataStateChange($event, dataItem.view)">
                <!--Flags columns-->
                <kendo-grid-column *ngIf="dataItem.category === 'flags'" field="description" [width]="100"
                    title="{{ 'DESCRIPTION' | translate }}">
                </kendo-grid-column>
                <kendo-grid-column *ngIf="dataItem.category === 'flags'" field="category.displayName" [width]="20"
                    title="{{ 'CATEGORY' | translate }}">
                </kendo-grid-column>
                <kendo-grid-column *ngIf="dataItem.category === 'flags'" field="priority.displayName" [width]="20"
                    title="{{ 'PRIORITY' | translate }}">
                </kendo-grid-column>
                <!--Needs columns-->
                <kendo-grid-column *ngIf="dataItem.category === 'needs'" field="serviceCategory.name" [width]="100"
                    title="{{ 'SERVICE-CATEGORY' | translate }}">
                </kendo-grid-column>
                <kendo-grid-column *ngIf="dataItem.category === 'needs'" field="serviceCategory.serviceType.displayName"
                    [width]="20" title="{{ 'COMMUNITY-SERVICE-TYPE' | translate }}">
                </kendo-grid-column>
                <!--Tasks columns-->
                <kendo-grid-column *ngIf="dataItem.category === 'tasks'" field="name" [width]="40"
                    title="{{ 'NAME' | translate }}">
                </kendo-grid-column>
                <kendo-grid-column *ngIf="dataItem.category === 'tasks'" field="description" [width]="100"
                    title="{{ 'DESCRIPTION' | translate }}">
                </kendo-grid-column>
                <kendo-grid-column *ngIf="dataItem.category === 'tasks'" field="dueDateDays" [width]="30"
                    title="{{ 'DUE-DATE' | translate }} ({{'IN-DAYS' | translate}})">
                </kendo-grid-column>
                <kendo-grid-column *ngIf="dataItem.category === 'tasks'" field="priority.text" [width]="20"
                    title="{{ 'PRIORITY' | translate }}">
                </kendo-grid-column>
                <kendo-grid-column *ngIf="dataItem.category === 'tasks'" field="taskAssessment.name" [width]="50"
                    title="{{ 'ASSESSMENT' | translate }}">
                </kendo-grid-column>
                <!--Channels columns-->
                <kendo-grid-column *ngIf="dataItem.category === 'channels'" field="channel.name" [width]="100"
                    title="{{ 'CHANNEL' | translate }}">
                </kendo-grid-column>
                <kendo-grid-column *ngIf="dataItem.category === 'channels'" field="priority.priorityName" [width]="20"
                    title="{{ 'PRIORITY' | translate }}">
                </kendo-grid-column>
                <!--Risks columns-->
                <kendo-grid-column *ngIf="dataItem.category === 'serviceTypes'" field="serviceType.displayName"
                    [width]="100" title="{{ 'COMMUNITY-SERVICE-TYPE' | translate }}">
                </kendo-grid-column>
                <kendo-grid-column *ngIf="dataItem.category === 'serviceTypes'" field="score" [width]="20"
                    title="{{ 'RISK-SCORE' | translate }}">
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </ng-template>
</kendo-grid>